<template>

  <fragment>
    <b-table striped :items="items"></b-table>
    Interno: {{botao.src}}
  </fragment>

</template>
<script>
import ButtonEntity from "@/model/entities/resource/entity/ButtonEntity";

export default {
  name: 't-list',
  props: {
    items: {
      type: Array,
      required: false
    },
    botao: ButtonEntity
  }
}
</script>
